import React, { useEffect, useRef, useState } from "react";
import './ShippingForm.scss';

import Init from "../../../../Init/Init";
import UtilityFunction from "../../../../Util/Util";
import { connect } from "react-redux";
import shippingAPI from "../../../../Data/Shipping";
import LoadingPage from "../../../Utilities/LoadingPage/LoadingPage";

const { numberFormatting } = UtilityFunction;

const mapStateToProps = (state) => {
    return {
        couriers: state.shipping.couriers,
        cart: state.shop.cartProducts
    }
};

const ShippingForm = (props) => {
    const radioRef = [
        useRef(),
        useRef(),
        useRef(),
        useRef(),
        useRef(),
    ];
    const [ existingCouriers, setExistingCouriers ] = useState([]);

    const chooseShipping = (index, value) => {
        props.onChange(value);
        radioRef[index].current.checked = radioRef[index].current.value == value;
        props.updateShippingFee(existingCouriers.hasOwnProperty(index) ? existingCouriers[index].discountPrice : 0);
    }

    useEffect( () => {
        if( props.couriers.length > 0 && props.cart ) {
            // Call Get Quotation here based on order
            (async () => {
                let quotationResult = {};

                for( let index in props.couriers ) {
                    const courier = props.couriers[index];
                    const cartItems = {...props.cart};
                    delete cartItems.transactionNotes;

                    let response = await shippingAPI.getQuotation(
                        courier.id,
                        props.formData.provinceId, props.formData.regencyId, props.formData.districtId, props.formData.villageId,
                        props.formData.address.replaceAll("&", "and"), 0, 0, props.formData.postalCode, cartItems
                    );

                    if( response.hasOwnProperty('errorCode') && response.errorCode === 0 ) {
                        quotationResult[courier.id] = response.data;
                    }
                }

                let c = [...props.couriers];
                c = c.map( (item, index) => {
                    item.status = 0;

                    if( quotationResult.hasOwnProperty(item.id) ) {
                        item.price = quotationResult[item.id].price;
                        item.discountPrice = item.price;
                        item.status = 1;

                        if( quotationResult[item.id].hasOwnProperty('discountRate') ) {
                            item.discountRate = 1 - quotationResult[item.id].discountRate;
                            item.discountPrice *= quotationResult[item.id].discountRate;
                        } 
                    }

                    return item;
                } );

                setExistingCouriers([...c]);
            } )();
        }
    }, [props.couriers, props.cart]);
    
    useEffect( () => {
        if( existingCouriers.length > 0 ) {
            radioRef[0].current.checked = radioRef[0].current.value === props.chosenShipping;
            // radioRef[1].current.checked = radioRef[1].current.value == props.chosenShipping;
        }
    }, [existingCouriers]);

    return (
        <div className="shipping-form">
            <h2 className="shipping-form-title">
                Opsi Pengiriman
            </h2>

            <div className="shipping-form-container">
                {
                    existingCouriers.length > 0 ? (
                        <>
                            {
                                existingCouriers.map( (item, index) => {
                                    const splittedName = item.courier_name.split(" ");

                                    return (
                                        <div key={index} className="shipping-form-option">
                                            <label htmlFor={ `courier-${index}` } className="courier-option">
                                                <input 
                                                    type="radio" 
                                                    id={ `courier-${index}` } 
                                                    name="shipping" 
                                                    value={ item.id } 
                                                    onClick={ () => chooseShipping(index, item.id) } 
                                                    disabled={ !item.status }
                                                    ref={ radioRef[index] }
                                                /> <img alt={`${ item.courier_name }`} src={`${ item.courier_logo }`} /> { splittedName[splittedName.length - 1] }
                                                {/* { item.courier_name } */}
                                                { item.hasOwnProperty('discountPrice') && item.discountPrice < item.price ? (
                                                    <span className="discount-badge">
                                                        { `-${ item.discountRate * 100 }%` }
                                                    </span>
                                                ) : "" }
                                            </label>
                                            <div className={`description ${ item.price > 0 ? "" : ( item.status ? "free" : "disabled") }`}>
                                                <span className={`original-price ${ item.hasOwnProperty('discountPrice') && item.discountPrice < item.price ? "discount" : "" }`}>
                                                    { item.price > 0 ? `${numberFormatting(item.price)} ~ ${parseFloat(item.price * 2).toLocaleString('id-ID')},00` : ( item.status ? "FREE" : "Not Available") }
                                                </span>
                                                {
                                                    item.hasOwnProperty('discountPrice') && item.discountPrice < item.price ? (
                                                        <span className="discount-price">
                                                            {
                                                                `${numberFormatting(item.discountPrice)} ~ ${parseFloat(item.discountPrice * 2).toLocaleString('id-ID')},00`
                                                            }
                                                        </span>
                                                    ) : ""
                                                }
                                            </div>
                                        </div>
                                    );    
                                } )
                            }
                            <div className="shipping-form-option">
                                <label htmlFor={ `courier-self-pickup` }>
                                    <input 
                                        type="radio" 
                                        id={ `courier-self-pickup` } 
                                        name="shipping" 
                                        value={ 0 } 
                                        onClick={ () => chooseShipping(existingCouriers.length > 0 ? existingCouriers.length : 0, 0) } 
                                        disabled={ false }
                                        ref={ radioRef[existingCouriers.length > 0 ? existingCouriers.length : 0] }
                                    /> 
                                    <img src={Init.config.icons.selfPickup} className="self-pickup-icon" alt="" /> Self Pickup
                                </label>
                                <span className={`description free`}>
                                    FREE
                                </span>
                            </div>
                            <div className="shipping-form-option">
                                <label className="shipping-notes">
                                    <span className="text-danger">*</span>Self Pickup hanya tersedia untuk domisili Jabodetabek.
                                </label>
                            </div>
                        </>
                    ) : <LoadingPage />
                }
            </div>
        </div>
    );
}

export default connect(mapStateToProps)(ShippingForm);